import { render, staticRenderFns } from "./FormSteps.vue?vue&type=template&id=74141195&"
import script from "./FormSteps.vue?vue&type=script&lang=js&"
export * from "./FormSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports